/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import React, { useState, useEffect } from 'react';

import { Form, Select } from 'antd';

import withTranslations from 'app/components/HOGs/withTranslations';

import PropTypes from 'prop-types';

import userAPI from 'app/API/user.service.api';

import mapUtils from 'app/libs/Utils/mapUtils';

import './selectCountry.css';

const SelectCountryForm = ({ form, data = {}, tr, ...props }) => {
  const [countryList, setCountryList] = useState([]);
  const [initialValue, setInitValue] = useState(undefined);

  const getInitialCountry = (code) => {
    const country = countryList.find((country) => country.code === code);
    if (country) {
      const { name, code } = country;
      return `${name}_${code}`;
    }
    return '';
  };

  const setDetectedCountry = () => {
    if (data && data.country) {
      setInitValue(getInitialCountry(data.country));
    } else {
      const { loc } = props;
      if (loc && (loc.lat || loc.lng))
        mapUtils.getTourstartGeocoder(loc, (resp) => {
          setInitValue(
            getInitialCountry(mapUtils.getTourstartCountryCode(resp.data))
          );
        });
    }
  };

  useEffect(() => {
    userAPI
      .getCountryList()
      .then((res) => {
        const { code, entities } = res;
        if (code === 200) {
          setCountryList(entities);
          setDetectedCountry();
        } else {
          console.info(res);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (!initialValue && countryList.length > 0) {
      setDetectedCountry();
    }
  });

  return (
    <Form.Item
      name="country"
      rules={[{ required: true, message: tr['Select country'] }]}
    >
      <Select
        showSearch
        filterOption={(input, { props }) => {
          return props.value.toLowerCase().indexOf(input.toLowerCase()) === 0;
        }}
        placeholder={tr['Select country']}
        getPopupContainer={(node) => node.parentNode}
        {...props}
      >
        {countryList.map(({ id, code, name }) => (
          <Select.Option value={`${name}_${code}`} key={id}>
            <div className="selectItemContent">
              {code ? (
                <img
                  src={require(`static/img/countries/${code.toLowerCase()}.png`)}
                  alt={code}
                />
              ) : null}
              {name}
            </div>
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

SelectCountryForm.displayName = 'SelectCountryForm';
SelectCountryForm.propTypes = {
  data: PropTypes.object,
  form: PropTypes.object.isRequired,
};

export default withTranslations(SelectCountryForm);
